<template>
  <CapacityDatabasePage
    :title="title"
    :hero="hero"
    :tabs="tabs"
    :is-authorized="isAuthorized"
  >
    <NuxtPage />
  </CapacityDatabasePage>
</template>

<script setup lang="ts">
import CapacityDatabasePage from '~/components/capacity-database/CapacityDatabasePage.vue'
import { ANODE } from '~/constants/services/constants'

import {
  CD_ANODE_CHECKBOXES,
  CD_ANODE_SLUG,
  CD_ANODE_UNAUTHORIZED_HERO,
  CD_ANODE_UNAUTHORIZED_TITLE,
} from '~/src/constants/capacity-database/anode'
import {
  CAPACITY_DATABASE_SUBSCRIPTIONS,
  METHODOLOGY_FILE_INFO,
} from '~/src/constants/capacity-database/common'

/** composables */
import { useAuthorization } from '~/composables/useAuthorization'

/** utils */
import { getServices } from '~/constants/services'
import useAuthStore from '~/stores/auth'

/** app */
definePageMeta({
  layout: 'services',
})
const { $config, $modal } = useNuxtApp()
const { hasAuthorized } = useAuthorization()
const authStore = useAuthStore()

/** refs */
const title = ref(CD_ANODE_UNAUTHORIZED_TITLE)
const file = ref(null)
const hero = ref(null)
const isAuthorized = ref(false)
const subscription = ref(CAPACITY_DATABASE_SUBSCRIPTIONS[CD_ANODE_SLUG])

/** computed */
const isAuthenticated = computed(() => authStore.authenticated)

const tabs = computed(() => {
  if (!isAuthenticated.value) return []
  return [
    {
      name: 'Anode',
      slug: ANODE.slug,
      url: `/${ANODE.slug}/capacity-database`,
    },
    {
      name: 'Sodium ion Anode',
      slug: 'sodium-ion-anode',
      url: `/${ANODE.slug}/capacity-database/sodium-ion-anode`,
    },
  ]
})

/** lifecycle */
onMounted(async () => {
  const initialValues = getServices(CD_ANODE_CHECKBOXES)
  $modal.setInitialFields(initialValues)
  if (isAuthenticated.value) {
    isAuthorized.value = await hasAuthorized(subscription.value)
  }
  if (!isAuthorized.value) {
    const methodologyInfo = METHODOLOGY_FILE_INFO[CD_ANODE_SLUG]
    file.value = {
      ...methodologyInfo,
      ID: $config.public[methodologyInfo.EnvKey],
    }
    hero.value = { ...CD_ANODE_UNAUTHORIZED_HERO, file: file.value }
  }
})
</script>
